import { API_REQUEST_PREFIX } from '@shared/config/api/api-prefixes';
import { CreateRequestsBeforePurchaseDataRequest, CreateRequestsBeforePurchaseDataResponse } from './request-types';
import { requestBaseApi } from '@entities/request/api/base';
import { orderApi } from '@entities/order/api/order-api';

export const requestApi = requestBaseApi.injectEndpoints({
    endpoints: (build) => ({
        createRequestBeforePurchase: build.mutation<
            CreateRequestsBeforePurchaseDataResponse,
            CreateRequestsBeforePurchaseDataRequest
        >({
            query: (data) => {
                return {
                    url: API_REQUEST_PREFIX,
                    method: 'POST',
                    body: { ...data },
                };
            },
            invalidatesTags: ['RequestsList'],
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    dispatch(orderApi.util.invalidateTags(['OrdersList']));
                } catch (err) {
                    console.log(err);
                }
            },
        }),
    }),
});

export const { useCreateRequestBeforePurchaseMutation } = requestApi;
